<template>
	<div class="container-fluid">
		<navigation-admin></navigation-admin>
		<div class="row row-fluid wrapper-flexbox">
			<sidebar-admin></sidebar-admin>
			<section class="col-sm-10 admin-background-shadow overflow">
				<div class="row">
					<div class="col-sm-5 padding-title">
						<p class="admin-header">Códigos de Promoción</p>
					</div>
					<div class="col-sm-offset-5 col-sm-2">
						<a v-link="{ path: '/admin/codigo-nuevo'}"type="button" class="btn btn-black btn-lg">Nuevo código</a>
					</div>
				</div>
				<div class="row row-fluid absolute">
					<div class="col-sm-12 table-responsive">
						<table-admin-codes></table-admin-codes>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import navigationAdmin from '../../components/Admin/Admin-navigation.vue';
import sidebarAdmin from '../../components/Admin/Admin-sidebar.vue';
import tableAdminCodes from '../../components/Admin/Admin-table-codes.vue';

export default {
  components: {
    navigationAdmin,
    sidebarAdmin,
    tableAdminCodes,
  },
};
</script>


// WEBPACK FOOTER //
// Admin-codes.vue?097d4b51